import { Link } from "react-router-dom";

const getWinnerUserId = (winner) =>
  winner?.userId?._id ||
  winner?.userId ||
  winner?.user?._id ||
  winner?.user ||
  winner?._id;

const WinnerCard = ({
  winner,
  rank,
  coins,
  isFirst = false,
}) => {
  if (!winner) return null;
  const userId = getWinnerUserId(winner);
  const winnerName = winner?.name || "User Deleted";

  return (
    <div
      className={`bg-purple-500 to-purple-700 rounded-2xl shadow-md border flex flex-col items-center justify-center
      ${isFirst ? "h-72 w-44" : "h-56 w-32"}`}
    >
      {rank === 1 && (
        <div className="text-4xl mb-2">
          👑
        </div>
      )}

      <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center font-bold text-xl">
        {winner?.name?.charAt(0)?.toUpperCase()}
      </div>

      <div className="mt-3 text-center">
        {userId ? (
          <Link
            to={`/dash/view-user/${userId}`}
            className="font-bold text-gray-800 hover:underline"
          >
            {winnerName}
          </Link>
        ) : (
          <h3 className="font-bold text-gray-800">
            {winnerName}
          </h3>
        )}

        <p className="text-sm text-gray-500">
          Rank #{rank}
        </p>

        <p className="mt-2 font-bold text-yellow-600">
          🪙 {winner?.coinsEarned || coins}
        </p>
      </div>
    </div>
  );
};

export default WinnerCard;
